import React from 'react';

import { Link, Text } from '@betterment/samba-react';

import urlBuilder from '../../../Shared/url-builder';

export const EditSecuritiesLendingTerms: React.FC = () => {
  return (
    <Text variant="text50" css={{ color: 'text.weak' }}>
      By electing to present the securities lending opt-in option to your client, you acknowledge and agree that you
      have diligently reviewed and confirmed, based on your client's financial profile, that securities lending is
      suitable and appropriate for your client's account. Your client will be required to agree to the{' '}
      <Link variant="textSecondary" href={urlBuilder.getSecuritiesLendingAgreement()} target="_blank">
        Apex Master Securities Lending Agreement
      </Link>{' '}
      and{' '}
      <Link variant="textSecondary" href={urlBuilder.getSecuritiesLendingDisclosure()} target="_blank">
        Important Disclosures
      </Link>{' '}
      before they opt in. Upon your client’s opt-in, they will be automatically enrolled once securities lending becomes
      available. Apex is the sole borrower of securities under the Fully-Paid Securities Lending (“FPSL”) Program and
      may lend out their securities. Loaned securities are not covered by SIPC, but are backed by at least 100% cash
      collateral held at a third-party bank. To learn more, please review our{' '}
      <Link variant="textSecondary" href={urlBuilder.getSecuritiesLendingFAQs()} target="_blank">
        FAQs
      </Link>{' '}
      or reach out to support.
    </Text>
  );
};
